import { connect } from 'react-redux';

import {
  getAllFromAddress,
  searchElections,
  setQueriedAddress,
} from '../../state/actions';

import Home from './component';

const mapStateToProps = (state) => {
  const {
    elections: {
      selectedElection,
    },
    races: {
      selectedRace,
    },
  } = state;

  return {
    selectedElection,
    selectedRace,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchElectionsByAddress: (address, successCallback, failureCallback) => {
      dispatch(getAllFromAddress(address, successCallback, failureCallback));
      dispatch(setQueriedAddress(address));
    },
    fetchElectionsBySearch: (phrase, successCallback, failureCallback) => {
      dispatch(searchElections(phrase, successCallback, failureCallback));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
